module.exports = __webpack_public_path__ + "img/bikes.1befafea.jpeg";